import React, { useState, useEffect } from 'react'
import { getSupplierInfoAPi, logOutApi } from '../../Api/BarestSupplierServices'
import BottomNavigation from '../../Components/BottomNavigation/BottomNavigation'
import Performancepoints from '../../Components/PerformancePoints/Performancepoints'
import SalesRepoart from '../../Components/salesRepoart/SalesRepoart'
import { useHistory } from 'react-router';
import Style from './Dashboard.module.css'
import { errorToast } from './../../Utils/Toast/Toast';
const Dashboard = () => {
    const[checkTable,setCheckTable]=useState(false)

    let history= useHistory()
    useEffect(()=>{
        getSupplierInfo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    //////////// get supplier info /////////////
    const getSupplierInfo=async()=>{ 
        getSupplierInfoAPi((succ,res)=>{
            if(succ){
                if(res.status===1){
                    if (res.info.lat==="" && res.info.lon===""){
                                setTimeout(() => {
                                    history.push('/selectaddress')
                                },0);
                            }
                }else{
                    errorToast(res.message)
                }
            }else{
                console.error(res)
            }
        })
    }
    return (
        <div className={Style.PageHolder}>
            <section className={Style.tabHolder}>
                <div className={checkTable?null:Style.onFocus} onClick={()=>setCheckTable(false)}>گزارش فروش</div>
                <div className={checkTable?Style.onFocus:null} onClick={()=>setCheckTable(true)}> امتیاز عملکرد</div>
            </section>
            {
                checkTable?<Performancepoints/>:<SalesRepoart/>
            }
            <BottomNavigation/>
        </div>
    )
}

export default Dashboard
